export default __webpack_public_path__ + "static/media/spinner.8c8c86d8.gif";